import React from 'react'
import { ButtonProps, Typography } from '@mui/material'
import { useAuth } from 'context/JWTContext'
import { useRouter } from 'next/router'
import { usePartnerPageDataStore } from '@/store/store'
import { FlowTypes } from '@/lib/constants'
import { withoutCharitySlug } from '@/utils/charitySlug'
import { HIDDEN_WITH_BOTTOM_NAV } from './shared/bottomNavStyles'

export default function LoginButton({ ...other }: ButtonProps) {
  const [partnerPageData] = usePartnerPageDataStore((state) => [state.partnerPageData])
  const router = useRouter()
  const { logout, isAuthenticated, isInitialized } = useAuth()

  const handleLogin = () => {
    if (partnerPageData?.is_external_login) {
      router.push({
        pathname: `/${router.query.slug}/auth/external-login`,
        query: { ...withoutCharitySlug(router.query), flowType: FlowTypes.AUTH },
      })
    } else {
      router.push({
        pathname: `/${router.query.slug}/auth/email-check`,
        query: { ...withoutCharitySlug(router.query), flowType: FlowTypes.AUTH },
      })
    }
  }

  if (!isInitialized) return <div style={{ width: '65px' }}>Loading...</div>

  if (isAuthenticated) {
    return (
      <div style={{ width: '65px' }}>
        <Typography
          fontFamily={partnerPageData?.fonts.secondary_font.family}
          fontWeight="bold"
          fontStyle="italic"
          onClick={() => logout(`/${router.query.slug}/landing`)}
          style={{ cursor: 'pointer', color: 'white' }}
        >
          Logout
        </Typography>
      </div>
    )
  }

  return (
    <Typography
      id="game_page_login_button"
      fontFamily={partnerPageData?.fonts.secondary_font.family}
      fontWeight="bold"
      fontStyle="italic"
      onClick={handleLogin}
      style={{ cursor: 'pointer', color: 'white', width: '65px' }}
      sx={HIDDEN_WITH_BOTTOM_NAV}
    >
      LOGIN
    </Typography>
  )
}
